import { useEffect, useState } from 'react';
import { api } from '@/lib/api';

export default function AdminAnalytics() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get('/admin/analytics').then(r => setD(r.data)); }, []);
  if (!d) return <div className="text-sm text-muted-foreground">Caricamento…</div>;

  const total = d.listings_by_type.reduce((a,b)=>a+b.count,0);
  const maxRegion = Math.max(1, ...d.listings_by_region.map(r=>r.count));

  return (
    <div className="space-y-8">
      <header>
        <div className="text-xs uppercase tracking-[0.2em] font-bold text-terracotta">Analytics</div>
        <h1 className="font-display text-3xl md:text-4xl tracking-tighter mt-2">Statistiche piattaforma</h1>
        <p className="mt-2 text-sm text-muted-foreground">Tutti i valori sono calcolati in tempo reale dal database. Se un dato non è disponibile, non viene inventato.</p>
      </header>

      <section className="grid md:grid-cols-2 gap-6">
        <div className="rounded-2xl border border-border bg-card p-6">
          <div className="text-xs uppercase tracking-widest text-muted-foreground mb-4">Distribuzione affitto / vendita</div>
          {d.listings_by_type.length===0 ? <div className="text-sm text-muted-foreground">Nessun terreno pubblicato</div> :
            <div className="space-y-3">
              {d.listings_by_type.map(t => (
                <div key={t.type}>
                  <div className="flex justify-between text-sm">
                    <span className="capitalize">{t.type === 'rent' ? 'Affitto' : 'Vendita'}</span>
                    <span className="text-muted-foreground">{t.count} annunci · {Math.round(t.total_area)} ha</span>
                  </div>
                  <div className="mt-2 h-2 rounded-full bg-secondary overflow-hidden">
                    <div className="h-full bg-foreground" style={{ width: `${(t.count/total)*100}%` }}/>
                  </div>
                </div>
              ))}
            </div>}
        </div>

        <div className="rounded-2xl border border-border bg-card p-6">
          <div className="text-xs uppercase tracking-widest text-muted-foreground mb-4">Utenti per ruolo</div>
          <div className="space-y-2 text-sm">
            {d.users_by_role.map(r => (
              <div key={r.role} className="flex justify-between">
                <span>{r.role || 'user'}</span>
                <span className="text-muted-foreground">{r.count}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="rounded-2xl border border-border bg-card p-6">
        <div className="text-xs uppercase tracking-widest text-muted-foreground mb-4">Terreni per regione</div>
        {d.listings_by_region.length===0 ? <div className="text-sm text-muted-foreground">Nessun dato regionale</div> :
          <div className="space-y-3">
            {d.listings_by_region.map(r => (
              <div key={r.region}>
                <div className="flex justify-between text-sm">
                  <span>{r.region}</span>
                  <span className="text-muted-foreground">{r.count} · {Math.round(r.total_area)} ha</span>
                </div>
                <div className="mt-1 h-1.5 rounded-full bg-secondary overflow-hidden">
                  <div className="h-full bg-terracotta" style={{ width: `${(r.count/maxRegion)*100}%` }}/>
                </div>
              </div>
            ))}
          </div>}
      </section>

      <section className="rounded-2xl border border-border bg-card p-6">
        <div className="text-xs uppercase tracking-widest text-muted-foreground mb-4">Nuovi utenti (30 giorni)</div>
        {d.users_growth_30d.length===0 ? <div className="text-sm text-muted-foreground">Nessuna registrazione recente</div> :
          <div className="flex items-end gap-1 h-32">
            {d.users_growth_30d.map(day => {
              const max = Math.max(...d.users_growth_30d.map(x=>x.count));
              return (
                <div key={day.day} className="flex-1 flex flex-col items-center justify-end" title={`${day.day}: ${day.count}`}>
                  <div className="w-full bg-foreground rounded-t" style={{ height: `${(day.count/max)*100}%` }}/>
                </div>
              );
            })}
          </div>}
      </section>

      <section className="rounded-2xl border border-border bg-card p-6">
        <div className="text-xs uppercase tracking-widest text-muted-foreground mb-4">Terreni per stato</div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 text-sm">
          {d.listings_by_status.map(s => (
            <div key={s.status} className="rounded-xl border border-border p-3">
              <div className="text-xs uppercase tracking-widest text-muted-foreground">{s.status}</div>
              <div className="font-display text-2xl">{s.count}</div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
